export default __webpack_public_path__ + "a0b9abd881a46c9f9819de3275c4185f.jpg";